<template>
  <div class="menu">
    <div class="top-title border-b border-section_border" id="top-title">
      <h1 class="top-title-heading" v-html="$t('tour_main_title')"></h1>
    </div>

    <Notice/>

    <div id="top-description" class="m-4">
      <p v-html="$t('tour_main_description')"></p>

      <div class="mt-4 text-sm">
        <ul class="list-note">
          <li v-if="$route.query.token === undefined">
            {{ $t('tour_require_login') }}
          </li>
          <li>
            {{ $t('tour_sub_description1') }}
          </li>
          <li>
            {{ $t('tour_sub_description2') }}
          </li>
        </ul>
      </div>
    </div>

    <MyPlan />

    <CourseList />

    <PoiList />

    <div class="mt-4 px-4">
      <router-link :to="{ name: 'faq' }" class="button-secondary block button-icon icon-right">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>{{ $t('tour_faq_label') }}</span>
      </router-link>
    </div>

    <div class="mt-4 px-4">
      <a :href="tohoku_maas_url()" class="button-secondary block button-icon icon-left">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_tohoku_maas_link') }}</span>
      </a>
    </div>

    <div class="m-4 text-sm" id="top-notice">
      <ul class="list-note">
        <li>
          {{ $t('tour_disclaimer_description1') }}
        </li>
        <li>
          {{ $t('tour_disclaimer_description2') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MyPlan from '../components/organisms/MyPlan.vue'
import CourseList from '../components/organisms/CourseList.vue'
import PoiList from '../components/organisms/PoiList.vue'
import Notice from '../components/organisms/Notice.vue'
import Constants from "../constants";

export default {
  name: 'Top',
  components: {
    MyPlan,
    CourseList,
    PoiList,
    Notice
  },
  mounted () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('genres/fetchAll')
      .then(() => {
        this.$store.dispatch('places/fetchPlaceGenres')
          .then(() => {
            this.$store.dispatch('loading/endLoading')
          })
      })
    if (this.$store.getters['user/getToken'] !== null) {
      this.$store.dispatch('favorites/fetchAll')
        .then(() => {
          this.$store.dispatch('plans/fetchAll')
        })
        .catch(() => {
          this.$store.dispatch('user/resetToken')
          this.$store.dispatch('plans/reset')
        })
    }
  },
  methods: {
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>

<style scoped>
</style>
